import sectionCardKeyFeaturesCss from '../css-snippets/section-card-key-features';

const html = `
<style>${sectionCardKeyFeaturesCss}</style>
<div
  id="card-key-features-section-unique-id"
  data-id="unique-id"
  class="key-features-wrapper"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="key-features-container container">
    <div class="key-features-header">
      <h2 style="text-align: center"><strong>Key Features</strong></h2>
      <p style="text-align: center">
        See some of the key features that make Airmoto the most trusted brand
        for portable tire inflators. With more than 25,545+ reviews, Airmoto is
        the perfect solution for your inflation needs.
      </p>
    </div>

    <div class="key-features-grid">
      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a16146210da7f3d14ab768.webp?w=500&h=50&q=80"
            alt="Powerful 120 PSI"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center"><strong>Powerful 120 PSI</strong></h3>
          <p style="text-align: center">
            Inflate virtually anything up to 120 PSI with the push of a button.
            Perfect for all vehicle types and more!
          </p>
        </div>
      </div>

      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1615ed2df4843fe5bba44.webp?w=500&h=50&q=80"
            alt="Rechargeable"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center"><strong>Rechargeable</strong></h3>
          <p style="text-align: center">
            Recharge your Airmoto with the included charging cable. Perfect for
            on-the-go and emergencies.
          </p>
        </div>
      </div>

      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1616f42e5056cb88daa40.webp?w=500&h=50&q=80"
            alt="Connects to Anything"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center">
            <strong>Connects to Anything</strong>
          </h3>
          <p style="text-align: center">
            Easily connects to anything with the included adapters, making it
            versatile and easy to use.
          </p>
        </div>
      </div>

      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a1617c89f9d93cd975b3cf.webp?w=500&h=50&q=80"
            alt="Auto Shut Off"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center"><strong>Auto Shut Off</strong></h3>
          <p style="text-align: center">
            Airmoto automatically shuts off when the desired PSI is reached,
            preventing over-inflation.
          </p>
        </div>
      </div>

      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a16191cfcdd3428406d144.webp?w=500&h=50&q=80"
            alt="Inflates & Deflates"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center">
            <strong>Inflates & Deflates</strong>
          </h3>
          <p style="text-align: center">
            Airmoto can also deflate, making it easy to adjust the pressure in
            your tires or inflatables.
          </p>
        </div>
      </div>

      <div class="key-feature-card">
        <div class="key-feature-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/02/27/image-69a161a2091ff1ab3c3a5020.webp?w=500&h=50&q=80"
            alt="LED Light"
          />
        </div>
        <div class="key-feature-content">
          <h3 style="text-align: center"><strong>LED Light</strong></h3>
          <p style="text-align: center">
            Airmoto has a built-in LED light, making it easy to use at night or
            in low-light conditions.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

`;

export default html;
